import './ImgCroper.scss';

import { PictureOutlined } from '@ant-design/icons';
import { Image, notification } from 'antd';
import { RcFile } from 'antd/es/upload';
import ImgCrop from 'antd-img-crop';
import { useEffect, useState } from 'react';
import { useRecoilState } from 'recoil';

import { key as UserProfileKey } from '../../../../../core/APIHooks/userData/useGetUserData';
import { userData as userRecoil } from '../../../../../recoil/atoms/userDataAtom';
import { DragUpload } from '../../../../components/upload/DragUpload';
import { key as UserDetailsKey } from '../../../../services/myProfile/useGetUserDetails';

export const ImgCroper = ({ setModalPhotoOpen }: any) => {
  const [user] = useRecoilState(userRecoil);
  //@ts-ignore
  const userId = user?.data?.profile.id;
  //@ts-ignore
  const profilePhoto = user?.data?.profile?.avatar_image?.thumbnail_url;
  const [imageUrl, setImageUrl] = useState<string>(profilePhoto ? profilePhoto : '');
  const BASE_URL = `${process.env.REACT_APP_API_URL}/`;

  useEffect(() => {
    setImageUrl(profilePhoto);
  }, [profilePhoto]);

  const beforeUploadImage = (file: RcFile) => {
    const isJpgOrPng =
      file.type === 'image/jpeg' ||
      file.type === 'image/jpg' ||
      file.type === 'image/png' ||
      file.type === 'image/bmp' ||
      file.type === 'image/gif';
    if (!isJpgOrPng) {
      notification.error({
        message: 'You can only upload JPG/PNG/BMP/GIF file!',
      });
    }
    const isLt2M = file.size / 1024 / 1024 < 10;
    if (!isLt2M) {
      notification.error({
        message: `Image ${file.name} must be smaller than 10MB!`,
      });
    }
    return isJpgOrPng && isLt2M;
  };

  return (
    <div className="image-croper-container">
      <ImgCrop rotationSlider>
        <DragUpload
          beforeUpload={beforeUploadImage}
          label="Upload Profile Photo"
          name={'profile_image'}
          data={{ version: '2', _method: 'PATCH' }}
          accept={'image/*'}
          action={`${BASE_URL}api/profiles/${userId}`}
          multiple={true}
          icon={<PictureOutlined />}
          queryKeyArray={[UserProfileKey, UserDetailsKey]}
          setModalPhotoOpen={setModalPhotoOpen}
        />
      </ImgCrop>
      <div className="profile-image-container">
        {imageUrl ? <Image src={imageUrl} alt="avatar" style={{ width: '100%' }} /> : null}
      </div>
    </div>
  );
};
